var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgConnectionRightArrow = function SvgConnectionRightArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 14,
    viewBox: "0 0 162 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2095_29209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 1,
    height: 14,
    fill: "#A1A4B1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.667,
    width: 1,
    height: 13,
    fill: "#A1A4B1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 156,
    height: 1,
    fill: "#A1A4B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.667 12.0858L159.813 8.93934L160.52 9.64645L156.167 14L151.813 9.64645L152.52 8.93934L155.667 12.0858V0.792893H156.667V12.0858Z",
    fill: "#A1A4B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2095_29209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.667,
    height: 14,
    fill: "white",
    transform: "translate(0.666626)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConnectionRightArrow);
export { ForwardRef as ReactComponent };